import Const from 'const';

interface attributeStructure {
    readonly headAttributeName: string;
    readonly playerPropName: string;
    readonly getPlayerPropValue: (player) => any;
    readonly isRequiredOnUploading: boolean;
}

const nameAttribute: attributeStructure = {
    headAttributeName: 'Name',
    playerPropName: 'name',
    getPlayerPropValue: (player) => player.name,
    isRequiredOnUploading: true,
};

const userPointsAttribute: attributeStructure = {
    headAttributeName: 'Points',
    playerPropName: 'userPoints',
    getPlayerPropValue: (player) => player.userPoints,
    isRequiredOnUploading: true,
};

const projectedOwnershipAttribute: attributeStructure = {
    headAttributeName: 'ProjOwn',
    playerPropName: 'projected_ownership',
    getPlayerPropValue: (player) => player.projOwn.getValue(),
    isRequiredOnUploading: false,
};

const cptProjectedOwnershipAttribute: attributeStructure = {
    headAttributeName: 'ProjOwnCPT',
    playerPropName: 'captain_projected_ownership',
    getPlayerPropValue: (player) => player.projOwn.getValue(Const.CAPTAIN_MODE),
    isRequiredOnUploading: false,
};

const starProjectedOwnershipAttribute: attributeStructure = {
    headAttributeName: 'ProjOwnSTAR',
    playerPropName: 'star_projected_ownership',
    getPlayerPropValue: (player) => player.projOwn.getValue(Const.STAR_MODE),
    isRequiredOnUploading: false,
};

const proProjectedOwnershipAttribute: attributeStructure = {
    headAttributeName: 'ProjOwnPRO',
    playerPropName: 'pro_projected_ownership',
    getPlayerPropValue: (player) => player.projOwn.getValue(Const.PRO_MODE),
    isRequiredOnUploading: false,
};

const flexProjectedOwnershipAttribute: attributeStructure = {
    headAttributeName: 'ProjOwnFLEX',
    playerPropName: 'projected_ownership',
    getPlayerPropValue: (player) => player.projOwn.getValue(),
    isRequiredOnUploading: false,
};

const ceilingPointsAttribute: attributeStructure = {
    headAttributeName: 'CeilingPoints',
    playerPropName: 'ceilingPoints',
    getPlayerPropValue: (player) => player.ceilingPoints,
    isRequiredOnUploading: false,
};

const cptCeilingPointsAttribute: attributeStructure = {
    headAttributeName: 'CeilingPointsCPT',
    playerPropName: 'captain_ceilingPoints',
    getPlayerPropValue: (player) => player.getPropValueOfMode('ceilingPoints', Const.CAPTAIN_MODE),
    isRequiredOnUploading: false,
};

const starCeilingPointsAttribute: attributeStructure = {
    headAttributeName: 'CeilingPointsSTAR',
    playerPropName: 'star_ceilingPoints',
    getPlayerPropValue: (player) => player.getPropValueOfMode('ceilingPoints', Const.STAR_MODE),
    isRequiredOnUploading: false,
};

const proCeilingPointsAttribute: attributeStructure = {
    headAttributeName: 'CeilingPointsPRO',
    playerPropName: 'pro_ceilingPoints',
    getPlayerPropValue: (player) => player.getPropValueOfMode('ceilingPoints', Const.PRO_MODE),
    isRequiredOnUploading: false,
};

const flexCeilingPointsAttribute: attributeStructure = {
    headAttributeName: 'CeilingPointsFLEX',
    playerPropName: 'ceilingPoints',
    getPlayerPropValue: (player) => player.ceilingPoints,
    isRequiredOnUploading: false,
};

const attributesMap = {
    draftkings: {
        cfb: {},
        f1: {},
        golf: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
            showdown: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
            tiers: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
        lol: {},
        mlb: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
            showdown: [
                nameAttribute,
                userPointsAttribute,
                cptProjectedOwnershipAttribute,
                flexProjectedOwnershipAttribute,
            ],
        },
        mma: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
            showdown: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
        nascar: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
        nba: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute, ceilingPointsAttribute],
            showdown: [
                nameAttribute,
                userPointsAttribute,
                cptProjectedOwnershipAttribute,
                flexProjectedOwnershipAttribute,
                cptCeilingPointsAttribute,
                flexCeilingPointsAttribute,
            ],
        },
        nfl: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute, ceilingPointsAttribute],
            showdown: [
                nameAttribute,
                userPointsAttribute,
                cptProjectedOwnershipAttribute,
                flexProjectedOwnershipAttribute,
                cptCeilingPointsAttribute,
                flexCeilingPointsAttribute,
            ],
            tiers: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute, ceilingPointsAttribute],
        },
        nhl: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
        tennis: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
    },
    fanduel: {
        cfb: {},
        golf: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
        lol: {},
        mlb: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
            'single-game': [
                nameAttribute,
                userPointsAttribute,
                cptProjectedOwnershipAttribute,
                // starProjectedOwnershipAttribute,
                flexProjectedOwnershipAttribute,
            ],
        },
        mma: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
        nascar: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
        nba: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute, ceilingPointsAttribute],
            'single-game': [
                nameAttribute,
                userPointsAttribute,
                cptProjectedOwnershipAttribute,
                // starProjectedOwnershipAttribute,
                // proProjectedOwnershipAttribute,
                flexProjectedOwnershipAttribute,
                cptCeilingPointsAttribute,
                // starCeilingPointsAttribute,
                // proCeilingPointsAttribute,
                flexCeilingPointsAttribute,
            ],
        },
        nfl: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute, ceilingPointsAttribute],
            'single-game': [
                nameAttribute,
                userPointsAttribute,
                cptProjectedOwnershipAttribute,
                flexProjectedOwnershipAttribute,
                cptCeilingPointsAttribute,
                flexCeilingPointsAttribute,
            ],
        },
        nhl: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute],
        },
    },
    yahoo: {
        nfl: {
            classic: [nameAttribute, userPointsAttribute, projectedOwnershipAttribute, ceilingPointsAttribute],
            'single-game': [
                nameAttribute,
                userPointsAttribute,
                cptProjectedOwnershipAttribute,
                flexProjectedOwnershipAttribute,
                cptCeilingPointsAttribute,
                flexCeilingPointsAttribute,
            ],
        },
    },
};

const AttributesMapFactory = {
    fromSportConfig(sportConfig): attributeStructure[] {
        const site = sportConfig.getSite().toLowerCase();
        const sport = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        return attributesMap[site][sport][gameType] || [nameAttribute, userPointsAttribute];
    },
};

export default AttributesMapFactory;

export {attributeStructure};
